import { Link } from "react-router-dom";
import { Layout, PageHero } from "../components/Layout";
import { Seo } from "../components/Seo";
import { ALL_OFFERINGS, PROJECTS, BLOGS, LEGAL_ENTITY, SECTOR_CASE_STUDIES } from "../data";

const GROUPS = [
  { title: "Main", links: [["Home", "/"], ["About", "/about"], ["Services", "/services"], ["Solutions", "/solutions"], ["Industries", "/industries"], ["Portfolio", "/portfolio"], ["Blog", "/blog"], ["Careers", "/careers"], ["Contact", "/contact"]] },
  { title: "Industries", links: Object.values(SECTOR_CASE_STUDIES).map((s) => [s.sector, `/industries/${s.slug}`]) },
  { title: "Products", links: ALL_OFFERINGS.filter((o) => o.type === "product").map((p) => [p.title, p.link]) },
  { title: "Services", links: ALL_OFFERINGS.filter((o) => o.type === "service").map((s) => [s.title, s.link]) },
  { title: "Portfolio", links: PROJECTS.map((p) => [p.title, `/portfolio/${p.slug}`]) },
  { title: "Blog", links: BLOGS.map((b) => [b.title, `/blog/${b.slug}`]) },
  { title: "Legal", links: [["Privacy Policy", "/legal/privacy"], ["Terms & Conditions", "/legal/terms"], ["Refund Policy", "/legal/refund"], ["Cookie Policy", "/legal/cookie"], ["Disclaimer", "/legal/disclaimer"], ["Cancellation Policy", "/legal/cancellation"]] },
];

export default function Sitemap() {
  return (
    <Layout>
      <Seo title="Sitemap" description={`Sitemap of the Neuravolt website, operated by ${LEGAL_ENTITY}.`} path="/sitemap" />
      <PageHero eyebrow="Sitemap" title="Explore the site" />
      <section className="py-16 px-5 sm:px-8">
        <div className="max-w-6xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {GROUPS.map((g) => (
            <div key={g.title}>
              <h2 className="font-display text-lg font-bold text-[#FF5A1F] mb-4">{g.title}</h2>
              <ul className="space-y-2">
                {g.links.map(([label, to]) => (
                  <li key={to}><Link to={to} className="text-neutral-600 hover:text-[#FF5A1F] transition-colors">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
